import {
  PERITADOR_ACT_BRANCH_OFFICE_BEGIN,
  PERITADOR_ACT_BRANCH_OFFICE_SUCCESS,
  PERITADOR_ACT_BRANCH_OFFICE_FAILURE,
  PERITADOR_ACT_BRANCH_OFFICE_DISMISS_ERROR,
} from './constants'
import { REACT_APP_API_ABM } from '../../../common/config'
import axios from 'axios'

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function actBranchOffice(args = {}) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PERITADOR_ACT_BRANCH_OFFICE_BEGIN,
    })
    const promise = new Promise(async (resolve, reject) => {
      const doRequest = axios.get(`${REACT_APP_API_ABM}/abms/branch_office/Car_lot/${args.car_lot_id}`)

    doRequest.then(
      (res) => {
      dispatch({
        type: PERITADOR_ACT_BRANCH_OFFICE_SUCCESS,
        data: res?.data?.data,
      })
      resolve()
      },
      (err) => {
        dispatch({
          type: PERITADOR_ACT_BRANCH_OFFICE_FAILURE,
          data: { error: err },
        })
        reject(err)
      },
    )
  })
    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissActBranchOfficeError() {
  return {
    type: PERITADOR_ACT_BRANCH_OFFICE_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PERITADOR_ACT_BRANCH_OFFICE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        actBranchOfficePending: true,
        currentBranchOffice: null,
        actBranchOfficeError: null,
      }

    case PERITADOR_ACT_BRANCH_OFFICE_SUCCESS:
      // The request is success
      return {
        ...state,
        actBranchOfficePending: false,
        actBranchOfficeError: null,
        currentBranchOffice: action.data,
      }

    case PERITADOR_ACT_BRANCH_OFFICE_FAILURE:
      // The request is failed
      return {
        ...state,
        actBranchOfficePending: false,
        actBranchOfficeError: action.data.error,
      }

    case PERITADOR_ACT_BRANCH_OFFICE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        actBranchOfficeError: null,
      }

    default:
      return state
  }
}
